import { Factory } from './factory';
import { Link } from '../link';
import { Position } from '../position';
import { QuickLink } from '../quick-link';
import { Injectable } from '@angular/core';
import { ApplicationStateService } from '../../services/application-state.service';
import { UrlWhitelist } from '../../../environments/configs/url-whitelist';
import { UrlHelper } from '../../utils/url';

@Injectable({
    providedIn: 'root'
})
export class LinkFactory implements Factory<Link> {

    constructor(private applicationStateService: ApplicationStateService) {
    }

    buildFromFactory(): Link {
        return undefined;
    }

    buildFromObject(jsonObject: any): Link {

        const link = new Link();
        link.id = jsonObject.id;
        link.pageId = jsonObject.pageId;

        const position = new Position();
        position.x = +jsonObject.position.x;
        position.y = +jsonObject.position.y;
        position.w = +jsonObject.position.w;
        position.h = +jsonObject.position.h;

        link.position = position;
        link.url = jsonObject.url;
        link.content = jsonObject.content;
        link.type = jsonObject.type;
        link.overlay = jsonObject.overlay;
        link.bypassCheck = this.getBypassCheck(jsonObject.url);

        return link;
    }

    buildFromQuickLink(quickLink: QuickLink, positionOffset: Position): Link {

        const link = new Link();
        link.pageId = quickLink.pageId;
        const position = Position.createEmptyPosition();
        link.id = quickLink.id + 1000000;
        if (quickLink.position) {
            position.x = +quickLink.position.x + positionOffset.x;
            position.y = +quickLink.position.y + positionOffset.y;
            position.w = +quickLink.position.w + positionOffset.w;
            position.h = +quickLink.position.h + positionOffset.h;
        }
        link.position = position;
        link.url = quickLink.link;

        if (!link.url.startsWith('http://') && !link.url.startsWith('https://')) {
            link.url = `https://${link.url}`;
        }

        link.type = 5;
        link.overlay = false;
        link.bypassCheck = this.getBypassCheck(quickLink.link);
        link.isSolutionLink = quickLink.isSolutionLink;

        return link;
    }

    private getBypassCheck(link: string): boolean {
        if (UrlWhitelist.isOnWhiteList(link)) {
            if (UrlHelper.isSameDomain(link, 'sia.education')) {
                return this.applicationStateService.bookConfig.bookPermissions.siaLinks.view;
            }
            if (UrlHelper.isSameDomain(link, 'eduvidual.at')) {
                return this.applicationStateService.bookConfig.bookPermissions.eduvidualLinks.view;
            }

            return this.applicationStateService.bookConfig.bookPermissions.link.view;
        }

        return this.applicationStateService.bookConfig.bookPermissions.externalLinks.view;
    }
}
